import { Injectable } from '@angular/core';
import { AuthenticationService } from '../auth/authentication.service';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { catchError, map } from 'rxjs/operators';
import { Observable, throwError, of as observableOf } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class OnboardService {

  private ENDPOINT_AI_IMPORT = "/ai-import";

  constructor(
       private http: HttpClient,
       private auth: AuthenticationService
  ) { }

   //**================================== Upload Asset CSV File =========================*/
    public uploadAssetCSVFile(fileName: string, formData: any, tenantId: any, moduleName: any) {
      // ✅ Use HttpClient with proper headers
      const headers = new HttpHeaders({
        'Authorization': 'Bearer ' + this.auth.getToken()
      });

      return this.http.post(
        environment.ai_base_url + this.ENDPOINT_AI_IMPORT + '/upload',
        formData,
        { headers: headers }
      ).pipe(
        map((resp: any) => {
          return resp;
        }),
        catchError((error) => {
          return throwError(error);
        })
      );
    }
  
    //**================================== Delete Attachment =========================*/
    public deleteAttachment(id: any) {
      return this.http
        .delete(environment.base_url + this.ENDPOINT_AI_IMPORT + id, {
          observe: "response",
        })
        .pipe(
          map((resp: any) => {
            return resp;
          }),
          catchError((error) => {
            return throwError(error);
          })
        );
    }

      // **************************************  Get Asset AI Map Data *************************************/
      public getCreateAIData(tenantId: any, fileName: any, outputLang: any, module: any): Observable<any> {
        const params = new HttpParams()
          .set("tenantId", tenantId)
          .set("fileName", fileName)
          .set("outputLang", outputLang)
          .set("module", module);
    
    
        console.log('Requesting API with params:', params);
    
        return this.http.get(environment.ai_base_url + this.ENDPOINT_AI_IMPORT + "/ai-map", {
          observe: "response", params: params
        }).pipe(
          map((response: any) => response),
          catchError(error => observableOf(error))
        );
      }

        /************************************************ Get CSV Headers ************************************************************************/
  public getCSVHeaders(tenantId: any, fileName: any, module: any): Observable<any> {

    const params = new HttpParams()
    .set("tenantId", tenantId)
    .set("fileName", fileName)
    .set("module", module);

    return this.http.get(environment.ai_base_url + this.ENDPOINT_AI_IMPORT + "/list-csv-headers" , { observe: "response", params:params })
      .pipe(
        map((resp: any) => {
          return resp;
        }),
        catchError((error) => {
          return throwError(error);
        })
      );
  }

  public postFinalizeAIData(body: any): Observable<any> {
    
  return this.http
  .post(environment.ai_base_url + this.ENDPOINT_AI_IMPORT + "/stats", body, {
    observe: "response",
  })
  .pipe(
    map(
      (resp: any) => {
        return resp;
      },
      catchError((error) => {
        //console.log(error);
        return throwError(error);
      })
    )
  );
  }

  public saveAssetConfigurations(body: any): Observable<any> {
    
    return this.http
    .post(environment.ai_base_url + this.ENDPOINT_AI_IMPORT + "/deposit-to-db", body, {
      observe: "response",
    })
    .pipe(
      map(
        (resp: any) => {
          return resp;
        },
        catchError((error) => {
          //console.log(error);
          return throwError(error);
        })
      )
    );
  }

  public inviteMembers(body: any): Observable<any> {
  
    return this.http
    .post(environment.base_url  + "/bulk/create-user", body, {
      observe: "response",
    })
    .pipe(
      map(
        (resp: any) => {
          return resp;
        },
        catchError((error) => {
          //console.log(error);
          return throwError(error);
        })
      )
    );
  }

  public doNotShowOnBoard(body: any): Observable<any> {
    return this.http.put(environment.base_url + "/update-user-onboard-flag?doNotShowOnBoard=" + body, {})
    .pipe(
      map((resp: any) => {
        return resp;
      }),
      catchError((error) => {
        return throwError(error);
      })
    );
  }

  public saveOnboardingSteps(body: any):Observable<any>{
    let queryParam: any = '';
    for (var key in body){
      queryParam += `${key}=${body[key]}`;
    }
    let url: string = environment.base_url+`/v2/onboarding/update-step?${queryParam}`;
    return this.http.put(url, {}, {observe: 'response'})
    .pipe(
      map((resp: any) => {
        return resp;
      }),
      catchError((error) => {
        return throwError(error);
      })
    );
  }
}